export default {
	emptyState: {
		description: 'We weren’t able to find any vehicles matching this make and model in the Live sale or Buy it now.',
		title: 'You’ve found a rare one',
	},

	heading: 'Available in Marketplace',

	nextButtonLabel: 'Show next similar vehicles',
	prevButtonLabel: 'Show previous similar vehicles',
};
